
export type Mode = 'read'|'user'|'design';

/* 'read' and 'user' are the same *render* of a poster — a record resolved against a design — and
   differ only in whether the canvas is editable. Every layout decision (wrapping a field's resolved
   text, dropping fields that resolve empty, clamping an overflowing box back into its parent) must
   therefore treat them alike, or the public page draws a different poster from the preview the
   designer signed off on. Only 'design' is the odd one out: it shows the template rather than a
   record, so it crops a field to its designed line count and keeps every child visible. */
export function isUserFacing(mode: Mode): boolean { return mode != 'design'; }

